/**
 * The size of each indent. Note that this is the total size including
 * the width of the vertical line.
 */
export const indentSizeS = 10
export const indentSizeM = 16

/**
 * The width of the vertical line.
 */
export const verticalLineWidth = 2

/**
 * Limit how deep we nest comments using the standard layout/visual style.
 * Comments nested deeper than that are displayed differently.
 */
export const nestLimit = 4
